/**
 * Fidelo — free-gift cart helper (v5, tiered). UX ONLY — this script enforces nothing.
 *
 * ENFORCEMENT lives in Shopify: the Personalised Paw Print Leash Holder is a
 * normal R150 product, and ORDER-LEVEL automatic discounts "Free gift (R1,000+
 * spent)", "2nd free gift (R2,000+ spent)" … "5th" each take R150 off once the
 * cart subtotal (after pack discounts, gift lines included) reaches R1,150 × n —
 * i.e. R1,000 × n of products plus n gifts. Order discounts stack with the
 * "Buy 2 / Buy 3" pack discounts, so packs and gifts always combine. Extra gifts
 * beyond the earned number are simply charged at R150.
 *
 * What this script does for the customer:
 *  - keeps ONE gift line whose quantity = floor(paid subtotal / R1,000), adding
 *    units as the cart grows so the tiers have a gift to pay for;
 *  - if units THIS SCRIPT added are not covered by the tiers (cart shrank),
 *    removes them again so nobody sees a surprise R150.
 *    Units the customer added themselves are never touched — they are paying;
 *  - swaps the gift colour from the cart panel; saves the pet name(s).
 * Loaded globally from layout/theme.liquid; listeners are document-level so
 * they survive cart section morphs.
 */
(function () {
  if (window.__wbGiftAuto) return;
  window.__wbGiftAuto = true;

  var GIFT_PRODUCT_ID = 9149651714211;
  var GIFT_VARIANTS = { Black: 47764855685283, White: 47765285404835 };
  var DEFAULT_COLOUR = 'Black';
  var STEP_CENTS = 100000; // R1,000 per gift — UX trigger only; the rule lives in the Shopify discount
  var MAX_GIFTS = 10;
  var KEY = 'wb-gift-auto-count'; // how many gift units this script added (sessionStorage)

  var busy = false;
  var queued = false;
  var desiredColour = null;
  var lastAttempt = ''; // "paid:want" we last acted on (prevents add/remove loops)

  function autoCount() {
    try { return parseInt(sessionStorage.getItem(KEY) || '0', 10) || 0; } catch (e) { return 0; }
  }
  function setAutoCount(n) {
    try { if (n > 0) sessionStorage.setItem(KEY, String(n)); else sessionStorage.removeItem(KEY); } catch (e) {}
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (response) { return response.json(); });
  }
  function getCart() {
    return fetch('/cart.js').then(function (response) { return response.json(); });
  }
  function notifyCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart || null, sourceId: 'wb-gift-auto', data: { source: 'wb-gift-auto', itemCount: cart ? cart.item_count : undefined } },
    }));
  }
  function refresh() { return getCart().then(notifyCartUpdate); }
  function clearGiftAttributes() {
    return postJson('/cart/update.js', { attributes: { 'Free gift - Pet name': '', 'Free gift - Colour': '' } });
  }

  // Gift units covered by the order-level "free gift" tiers (R150 each).
  function tierFreeUnits(cart) {
    var total = 0;
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      if (/free gift/i.test(app.title || '')) total += app.total_allocated_amount || 0;
    });
    return Math.round(total / 15000);
  }

  function evaluate() {
    if (busy) { queued = true; return; }
    busy = true;

    getCart()
      .then(function (cart) {
        var gifts = [];
        var paid = 0;
        cart.items.forEach(function (line) {
          if (line.product_id === GIFT_PRODUCT_ID) gifts.push(line);
          else paid += line.final_line_price;
        });
        var have = gifts.reduce(function (n, l) { return n + l.quantity; }, 0);
        var free = Math.min(have, tierFreeUnits(cart));
        var want = Math.min(Math.floor(paid / STEP_CENTS), MAX_GIFTS);
        var mine = Math.min(autoCount(), have);
        if (mine !== autoCount()) setAutoCount(mine);
        var stamp = paid + ':' + want + ':' + have + ':' + free;

        // 1. Fewer gifts than earned: add the difference (once per cart state).
        if (have < want) {
          if (lastAttempt === stamp) return;
          lastAttempt = stamp;
          var variant = GIFT_VARIANTS[desiredColour] || GIFT_VARIANTS[DEFAULT_COLOUR];
          if (gifts.length) variant = gifts[0].variant_id;
          var delta = want - have;
          return postJson('/cart/add.js', { items: [{ id: variant, quantity: delta }] })
            .then(function () { setAutoCount(mine + delta); queued = true; }) // re-check what Shopify discounted
            .then(refresh);
        }

        // 2. Some gift units are NOT free: remove only the ones this script added.
        if (have > free && mine > 0) {
          var removable = Math.min(mine, have - free);
          if (removable <= 0) return;
          if (lastAttempt === stamp) return;
          lastAttempt = stamp;
          var ops = Promise.resolve();
          var left = removable;
          gifts.forEach(function (line) {
            if (left <= 0) return;
            var take = Math.min(line.quantity, left);
            left -= take;
            var newQty = line.quantity - take;
            ops = ops.then(function () { return postJson('/cart/change.js', { id: line.key, quantity: newQty }); });
          });
          return ops
            .then(function () {
              setAutoCount(mine - removable);
              if (have - removable === 0) return clearGiftAttributes();
            })
            .then(refresh);
        }

        // 3. Colour change requested: move the whole gift line to the other variant.
        if (desiredColour && GIFT_VARIANTS[desiredColour] && gifts.length) {
          var line = gifts[0];
          var wantVariant = GIFT_VARIANTS[desiredColour];
          if (line.variant_id !== wantVariant) {
            var qty = gifts.reduce(function (n, l) { return n + l.quantity; }, 0);
            var clear = Promise.resolve();
            gifts.forEach(function (g) { clear = clear.then(function () { return postJson('/cart/change.js', { id: g.key, quantity: 0 }); }); });
            return clear
              .then(function () { return postJson('/cart/add.js', { items: [{ id: wantVariant, quantity: qty }] }); })
              .then(refresh);
          }
        }
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
        if (queued) { queued = false; evaluate(); }
      });
  }

  document.addEventListener('cart:update', function (event) {
    var source = event && event.detail && event.detail.data && event.detail.data.source;
    if (source === 'wb-gift-auto') return;
    lastAttempt = '';
    setTimeout(evaluate, 80);
  });

  // ---- Gift panel interactions (document-level: the panel is re-rendered by cart morphs) ----
  function showSaved(el) {
    var box = el.closest('[data-wb-gift]');
    if (!box) return;
    var saved = box.querySelector('[data-wb-gift-saved]');
    if (!saved) return;
    saved.hidden = false;
    clearTimeout(box.__wbT);
    box.__wbT = setTimeout(function () { saved.hidden = true; }, 1600);
  }

  var petNameTimer;
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (target && target.hasAttribute && target.hasAttribute('data-wb-gift-pet')) {
      clearTimeout(petNameTimer);
      var value = target.value;
      petNameTimer = setTimeout(function () {
        postJson('/cart/update.js', { attributes: { 'Free gift - Pet name': value } })
          .then(function () { showSaved(target); })
          .catch(function () {});
      }, 500);
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.hasAttribute && target.hasAttribute('data-wb-gift-colour')) {
      desiredColour = target.value === 'White' ? 'White' : 'Black';
      lastAttempt = '';
      evaluate();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }
})();